app.ui.registerUi('openSocialLink', function(app) {
	var helpers = app.helpers.funcs;
    return {

        // We only need to register delegated event listeners once.
        // Init may be called more than once.
        // Therefore, log if the delegated event listeners have been added already, setting to true when a call to addDelegatedEventListeners occurs.
        // Then, don't add them again if this flag is set to true.
        delegatedEventListenersRegistered: false,

        implementationExists: function () {
            return true;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function($scope) {
            if (!this.implementationExists()) return;
            this.addDelegatedEventListeners();
        },
        addDelegatedEventListeners: function () {
            var scope = this;
            if (this.delegatedEventListenersRegistered) return;

            // If we are not on a mobile device, open all share links in a borderless window.
            if (!app.helpers.funcs.isMobile()) {
                $('body').on('click', 'a.opens-in-social-popup', function (e) {
                    e.preventDefault();
                    var href = $(this).attr('href');
                    app.helpers.funcs.openBorderlessLink(href);
                });
            }
            scope.delegatedEventListenersRegistered = true;
        }
	};
});
